import classNames from "classnames"
import React from "react"

import TextButton from "./Buttons/TextButton"
import ArrowIcon from "./Icons/ArrowIcon"
import StarIcon from "./Icons/StarIcon"
import Typography, { TypographySize } from "./Typography"
import { Color } from "../../../constants/V2/color"
import splitText from "../../../utils/V2/splitText"

import { getBorderColorClass } from "@utils/V2/color"

export type CalloutProps = {
  color?: Color
  classname?: string
  text: string
  textSize?: TypographySize
  highlightedWord: string
  highlightColor?: Color
  hasBorder?: boolean
  hasIcon?: boolean
  ctaText?: string
  ctaLink?: string
}

const Callout = ({
  color = Color.Charcoal,
  classname,
  text,
  textSize = "body-md",
  highlightedWord,
  highlightColor = Color.Blue,
  hasBorder = true,
  hasIcon = true,
  ctaText,
  ctaLink,
}: CalloutProps) => {
  const [firstSection, secondSection] = splitText(text, highlightedWord)
  return (
    <div
      className={classNames(
        getBorderColorClass(color),
        "flex w-fit flex-row items-center justify-center gap-x-4",
        {
          "rounded-40 border border-black border-opacity-10 px-8 py-[7px] md:px-16":
            hasBorder,
        },
        classname
      )}
    >
      {hasIcon && (
        <StarIcon
          color={color}
          className={classNames({ "-mt-[3px]": !hasBorder })}
        />
      )}
      <div className={classNames("flex gap-x-4", { "mt-[3px]": hasBorder })}>
        <Typography
          color={color}
          text={firstSection}
          font="grotesk"
          size={textSize}
          weight="book"
        />
        <Typography
          color={highlightColor}
          text={text.includes(highlightedWord) ? highlightedWord : ""}
          font="grotesk"
          size={textSize}
          weight="book"
        />
        <Typography
          color={color}
          text={secondSection}
          font="grotesk"
          size={textSize}
          weight="book"
        />
        {ctaText && ctaLink && (
          <TextButton
            text={ctaText}
            linkUrl={ctaLink}
            color={highlightColor}
            style="icon"
            icon={<ArrowIcon />}
            className="ml-10 pt-[2px]"
          />
        )}
      </div>
    </div>
  )
}

export default Callout
